import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">{t("error.404.code")}</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t("error.404.heading")}</p>
        <p className="mb-4 text-sm text-muted-foreground">{t("error.404.description")}</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          {t("error.404.backHome")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
